<form (ngSubmit)="submitCode()" class="verification">
  <h4 [innerText]="'LogIn.EnterYourCode' | translate" class="body-large text-center text-decoration-dark mb-4"></h4>
  <div class="text-left">
    <div class="input-primary-container verification-codes">
      <div aria-label="verification code" class="d-flex mt-2" id="verification-code" role="group">
        <div class="input-primary-container">
          <input aria-label="Code digit 1 of 6" autocomplete="one-time-code" class="input-primary code" id="code-1"
                 inputmode="text" maxlength="1" />
        </div>
        <div class="input-primary-container">
          <input aria-label="Code digit 2 of 6" autocomplete="off" class="input-primary code" id="code-2"
                 inputmode="text" maxlength="1" />
        </div>
        <div class="input-primary-container">
          <input aria-label="Code digit 3 of 6" autocomplete="off" class="input-primary code" id="code-3"
                 inputmode="text" maxlength="1" />
        </div>
        <div class="input-primary-container">
          <input aria-label="Code digit 4 of 6" autocomplete="off" class="input-primary code" id="code-4"
                 inputmode="text" maxlength="1" />
        </div>
        <div class="input-primary-container">
          <input aria-label="Code digit 5 of 6" autocomplete="off" class="input-primary code" id="code-5"
                 inputmode="text" maxlength="1" />
        </div>
        <div class="input-primary-container">
          <input aria-label="Code digit 6 of 6" autocomplete="off" class="input-primary code" id="code-6"
                 inputmode="text" maxlength="1" />
        </div>
      </div>
    </div>
  </div>

  <button [innerText]="'LogIn.ConfirmAccessCode' | translate" class="button-primary w-full"
          type="submit"></button>
</form>
